import { useCallback } from 'react';
import { useBaseI18n } from './i18n-hooks';
var useGetError = function () {
    var errors = useBaseI18n(function (i18n) { return i18n.error; });
    return useCallback(function (error) {
        var _a;
        switch (error === null || error === void 0 ? void 0 : error.status) {
            case 413:
                return errors.tooHeavy;
            case 400:
                if ((error === null || error === void 0 ? void 0 : error.data.message[0]) === 'Please enter a phone number without any spaces or dashes')
                    return errors.phoneWoOther;
                else
                    return errors.invalidInfo;
            case 500:
                if (((_a = error.data) === null || _a === void 0 ? void 0 : _a.code) === "ENAMETOOLONG")
                    return errors.fileNameTooLong;
                else
                    return errors.generalSystem;
            case 409:
                if ((error === null || error === void 0 ? void 0 : error.data.message) === 'association name already exists')
                    return errors.associationNameExists;
                return errors.phoneExists;
            default: return errors.generalSystem;
        }
    }, [errors]);
};
export default useGetError;
//# sourceMappingURL=useGetError.js.map